import { useState, useEffect } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface SlideData {
  image: string;
  title?: string;
  subtitle?: string;
}

const slides: SlideData[] = [
  {
    image: '/wp-content/uploads/2017/04/shooting-slider-1024x284.jpg',
  },
  {
    image: '/wp-content/uploads/2017/06/MinuteManSportsmansClub-1024x284.jpg',
  },
];

export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative">
      {/* Alert Banner */}
      <div className="bg-primary-yellow text-black py-2 px-4">
        <p className="text-center font-bold">
          <span className="font-black">ALERTS:</span> None at this time!
        </p>
      </div>

      {/* Hero Slider */}
      <div className="relative h-72 md:h-96 lg:h-[500px] overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="w-full h-full bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url(${resolveImagePath(slide.image)})`,
              }}
            />
          </div>
        ))}

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded hover:bg-opacity-70 transition-all"
          aria-label="Previous slide"
        >
          <span className="text-sm font-bold">Previous</span>
        </button>
        
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded hover:bg-opacity-70 transition-all"
          aria-label="Next slide"
        >
          <span className="text-sm font-bold">Next</span>
        </button>

        {/* Overlay Navigation Menu */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
          <nav>
            <ul className="flex space-x-4 bg-black bg-opacity-50 px-4 py-2 rounded">
              <li>
                <a 
                  href="/facility/trap/" 
                  className="text-white hover:text-primary-yellow transition-colors text-sm font-bold"
                >
                  Trap
                </a>
              </li>
              <li>
                <a 
                  href="/facility/skeet/" 
                  className="text-white hover:text-primary-yellow transition-colors text-sm font-bold"
                >
                  Skeet
                </a>
              </li>
              <li>
                <a 
                  href="/facility/5-stand/" 
                  className="text-white hover:text-primary-yellow transition-colors text-sm font-bold"
                >
                  5 Stand
                </a>
              </li>
              <li>
                <a 
                  href="/facility/sporting-clays/" 
                  className="text-white hover:text-primary-yellow transition-colors text-sm font-bold"
                >
                  Sporting Clays
                </a>
              </li>
              <li>
                <a 
                  href="/facility/youth/" 
                  className="text-white hover:text-primary-yellow transition-colors text-sm font-bold"
                >
                  Youth
                </a>
              </li>
            </ul>
          </nav>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-16 left-1/2 -translate-x-1/2">
          <div className="flex space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentSlide
                    ? 'bg-primary-yellow'
                    : 'bg-white bg-opacity-50 hover:bg-opacity-70'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="bg-primary-cream py-8 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-primary-navy mb-4">
            <strong>Shooting Since 1934</strong>
          </h1>
          <p className="text-text-dark text-lg mb-4 max-w-4xl mx-auto">
            Located on approximately 100 acres in Billerica, Massachusetts the Club consists of 8 skeet fields, 
            14 trap fields, 16 station sporting clays course and a 5 stand sporting clays field.
          </p>
          <p className="text-text-dark text-lg max-w-4xl mx-auto">
            The membership regularly promotes the shotgun shooting sports by hosting some of the most prestigious 
            Skeet, Trap and Sporting Clays tournaments held in the northeast.
          </p>
        </div>
      </div>
    </div>
  );
}